import $ from 'jquery';
import { setSiteVal } from 'sites';

/*global OLUtils */

export function onAddRoute(data) {
    $('#addRoute')
        .val(
            JSON.stringify({
                municipalities: data.municipalities.map(convertMunicipalityFeature),
                route: mergeRouteSegments(data.route.map(convertRouteFeature))
            })
        )
        .prop('disabled', false)
        .closest('form')
        .submit();
}

export function onModifySection(feature) {
    const p = feature.getProperties();

    setSiteVal(p.caseIndex, p.siteIndex, 'chainage.fromKm', p.from.km);
    setSiteVal(p.caseIndex, p.siteIndex, 'chainage.fromM', p.from.m);
    setSiteVal(p.caseIndex, p.siteIndex, 'chainage.toKm', p.to.km);
    setSiteVal(p.caseIndex, p.siteIndex, 'chainage.toM', p.to.m);
}

function convertMunicipalityFeature(feature) {
    /**
     * @type {{ Kommune }}
     */
    const properties = feature.getProperties();
    return {
        authority: properties['Kommune.kode'],
        authorityName: properties.Kommune,
        wkt: OLUtils.WKT.writeFeature(feature)
    }
}

/**
 * @param feature
 * @returns {RouteSegment}
 */
function convertRouteFeature(feature) {
    /**
     * @type {{ CPR_vejnavn, Vejbeskrivelse, Admvejnr, Admvejdel, Frakmt, Tilkmt }}
     */
    const properties = feature.getProperties();

    const authority = properties['Tilladelse_Vedligeholder.kode'] || properties['Bestyrer.kode'];
    const streetName = authority === '0'
        ? properties.Vejbeskrivelse || properties.CPR_vejnavn
        : properties.CPR_vejnavn || properties.Vejbeskrivelse;
    return {
        authority,
        streetName,
        admRoadNumber: properties.Admvejnr,
        admRoadPart: properties.Admvejdel,
        fromKmt: properties.Frakmt > properties.Tilkmt ? properties.Tilkmt : properties.Frakmt,
        toKmt: properties.Tilkmt < properties.Frakmt ? properties.Frakmt : properties.Tilkmt,
        // wkt: OLUtils.WKT.writeFeature(feature)
    }
}

/**
 * @param {Array<RouteSegment>} segments
 * @returns {Array<RouteSegment>}
 */
function mergeRouteSegments(segments) {
    /** @type {Array<RouteSegment>} */
    const result = [];
    /** @type {RouteSegment} */
    let last;

    segments.forEach(segment => {
        if (last
            && last.authority === segment.authority
            && last.admRoadNumber === segment.admRoadNumber
            && last.admRoadPart === segment.admRoadPart
            && last.toKmt === segment.fromKmt) {
            last.toKmt = segment.toKmt;
        } else {
            last = segment;
            result.push(segment);
        }
    });

    return result;
}

/**
 * @typedef {Object} RouteSegment
 * @property {string} authority
 * @property {string} streetName
 * @property {number} admRoadNumber
 * @property {string} admRoadPart
 * @property {number} fromKmt
 * @property {number} toKmt
 * @property {string} [wkt]
 */
